import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Typography,
  Card,
  Statistic,
  Spin,
  Button,
  Tooltip,
  Row,
  Col,
  Flex,
  Steps,
  Form,
} from "antd";

//PROJECT IMPORTS
import { labelConfig, staticConfig, apiConfig } from "../../customer.config";
import MainLayout from "../../../../components/layouts/MainLayout";
import CustomButton from "../../../../components/custom/CustomButton";
import TopContent from "../../../../components/layouts/TopContent";
// import "./index.css";
import { useForm } from "antd/lib/form/Form";
import DetailsForm from "./components/DetailsForm";
import TermsForm from "./components/TermsForm";
import SettingsForm from "./components/SettingsForm";
import ChargesForm from "./components/ChargesForm";
import InterestRateChart from "./components/InterestRateChart";
import Preview from "./components/Preview";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import definedApi from "../../../../services/definedApi";
import styles from "../../../../assets/styles/styles";
import dayjs from "dayjs";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const NewRecurringDepositAccount = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { Text, Title } = Typography;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  // const [form] = useForm();

  // const createStandingInstruction = Form.useWatch("createStandingInstruction", useForm);
  // console.log(createStandingInstruction);

  const [templateProdDetail, setTemplateProdDetail] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [current, setCurrent] = useState(0);
  // const [customerDetail, setCustomerDetail] = useState([]);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [customerParam, setCustomerParam] = useState({});
  const [searchParam, setSearchParam] = useState("");
  // CHARGES FORM REQURED VARIABLES
  const [chargeTableSource, setChargeTableSource] = useState([]);

  // ENDPOINT DECLARED VARIABLES
  const [productData, setProductData] = useState([]);
  const [fieldOfficerData, setFieldOfficerData] = useState([]);
  const [currencyData, setCurrencyData] = useState({});
  const [
    interestCompoundingPeriodTypeOptions,
    setInterestCompoundingPeriodTypeOptions,
  ] = useState([]);
  const [
    interestPostingPeriodTypeOptions,
    setInterestPostingPeriodTypeOptions,
  ] = useState([]);
  const [interestCalculationTypeOptions, setInterestCalculationTypeOptions] =
    useState([]);
  const [
    interestCalculationDaysInYearTypeOptions,
    setInterestCalculationDaysInYearTypeOptions,
  ] = useState([]);
  const [
    lockinPeriodFrequencyTypeOptions,
    setLockinPeriodFrequencyTypeOptions,
  ] = useState([]);
  const [periodFrequencyTypeOptions, setPeriodFrequencyTypeOptions] = useState(
    []
  );

  const [charges, setCharges] = useState([]);
  const [chargesOptions, setChargesOptions] = useState([]);

  const [currency, setCurrency] = useState("");
  // DECLARED VARIABLES FOR CHARRGES FORM
  const [chargesValue, setChargesValue] = useState(null);

  // ENDPOINT DECLARED VARIABLES
  const [interestRateChartTableSource, setInterestRateChartTableSource] =
    useState([]);
  const [maturityInstructionData, setMaturityInstructionData] = useState([]);
  const [savingsAccountData, setSavingsAccountData] = useState([]);
  const [savingsProductData, setSavingsProductData] = useState([]);
  const [interestChartDate, setInterestChartDate] = useState(null);
  const [preClosure, setPreClosure] = useState(null);
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [isWithholdTaxValue, setIsWithholdTaxValue] = useState(null);

  const [formData, setFormData] = useState({
    details: null,
    currency: null,
    terms: null,
    settings: null,
    interestRateChart: null,
    charges: null,
    accounting: null,
  });

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    if (!searchKey) {
      return;
    }

    setSearchParam(searchKey);
  }

  const onSearch = () => {
    //clear form
    useForm.resetFields();

    if (!searchParam.trim()) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }
    const params = {
      exactMatch: true,
      query: searchParam.trim(),
      resource: "clients,clientIdentifiers",
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Search, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempProducts = [];

        objList?.forEach((element) => {
          tempProducts.push({
            entityAccountNo: element.entityAccountNo
              ? element.entityAccountNo
              : "",
            entityId: element.entityId ? element.entityId : "",
            entityMobileNo: element.entityMobileNo
              ? element.entityMobileNo
              : "",
            entityName: element.entityName ? element.entityName : "",
            entityType: element.customerType ? element.customerType : "",
          });
        });

        // console.log(tempProducts[0]);
        // return;

        if (tempProducts[0] === undefined) {
          BOM.AlertMsg(cnt.DANGER, "No matching client found.");
          setShowDetailsForm(false);
          setIsLoading(false);
          return;
        }

        setCustomerParam(tempProducts[0]);
        setCustomerInfo(tempProducts[0]);
        getProductTemplate(tempProducts[0]);
        setShowDetailsForm(true);
        setIsLoading(false);
      }
    });
  };

  const getProductTemplate = (customerParam) => {
    const params = {
      clientId: customerParam.entityId,
      // staffInSelectedOfficeOnly: true,
    };

    const url = `${apiConfig.Recurringdepositaccounts}/template`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempProducts = [];

        // console.log(objDetail);

        objDetail?.productOptions?.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.name ? `${element.name} (${element.id})` : "",
          });
        });

        setProductData(tempProducts);
        setCustomerInfo(customerParam);
        // setShowDetailsForm(true);
        // setIsLoading(false);
      }
    });
  };

  const onChangeProduct = (productParam) => {
    const params = {
      clientId: customerInfo.entityId,
      productId: productParam,
      // staffInSelectedOfficeOnly: true,
    };

    const url = `${apiConfig.Recurringdepositaccounts}/template`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setTemplateProdDetail(res);
        const objList = res;
        const productCurrency = objList?.currency?.code;

        console.log(productCurrency);
        let tempProducts = [];
        let tempFieldOfficer = [];
        let tempCurrency = objList?.currency;
        let tempInterestCompoundingPeriodTypeOptions = [];
        let tempInterestPostingPeriodTypeOptions = [];
        let tempInterestCalculationTypeOptions = [];
        let tempInterestCalculationDaysInYearTypeOptions = [];
        let tempLockinPeriodFrequencyTypeOptions = [];
        let tempPeriodFrequencyTypeOptions = [];
        let tempPreClosurePenalInterestOnTypeOptions = [];
        let tempTaxGroupOptions = [];
        let tempAssetOptions = [];
        let tempEquityOptions = [];
        let tempExpenseOptions = [];
        let tempIncomeOptions = [];
        let tempLiabilityOptions = [];
        let tempCharges = [];
        let tempInterestRateChart = [];
        let tempFromDate = objList?.accountChart?.fromDate;
        let tempChargesOptions = [];
        let tempPenaltyOptions = [];
        let tempPaymentTypeOptions = [];
        let tempMaturityInstruction = [];
        let tempSavingsAccountOptions = [];
        let tempSavingsProductOptions = [];

        // console.log(objList);

        useForm.setFieldsValue({
          currencyName: `${objList?.currency?.name} (${objList?.currency?.code})`,
          decimalPlaces: objList?.currency?.decimalPlaces,
          inMultiplesOf: objList?.currency?.inMultiplesOf,
          submittedOnDate: dayjs(),
          preMatureClosure: `Apply Penal Interest (less) ${
            objList?.preClosurePenalInterest
              ? objList?.preClosurePenalInterest
              : ""
          } - On ${
            objList?.preClosurePenalInterestOnType?.value
              ? objList?.preClosurePenalInterestOnType?.value
              : ""
          }`,
          nominalAnnualInterestRate: objList?.nominalAnnualInterestRate,
          interestCompoundingPeriodType:
            objList?.interestCompoundingPeriodType?.id,
          interestPostingPeriodType: objList?.interestPostingPeriodType?.id,
          interestCalculationType: objList?.interestCalculationType?.id,
          interestCalculationDaysInYearType:
            objList?.interestCalculationDaysInYearType?.id,
          minRequiredOpeningBalance: objList?.minRequiredOpeningBalance,
          lockinPeriodFrequency: objList?.lockinPeriodFrequency,
          lockinPeriodFrequencyType: objList?.lockinPeriodFrequencyType?.id,
          allowWithdrawal: objList?.allowWithdrawal,
          adjustAdvanceTowardsFuturePayments:
            objList?.adjustAdvanceTowardsFuturePayments,
          isMandatoryDeposit: objList?.isMandatoryDeposit,
          isCalendarInherited: objList?.isCalendarInherited,
          mandatoryRecommendedDepositAmount: objList?.depositAmount,
          minBalanceForInterestCalculation:
            objList?.minBalanceForInterestCalculation,
          minDepositTermDisplay:
            objList?.minDepositTerm && objList?.minDepositTermType?.value
              ? `${objList.minDepositTerm} - ${objList.minDepositTermType.value}`
              : "-",
          minDepositTerm: objList?.minDepositTerm || null,
          inMultiplesOfDepositTerm: `${
            objList?.inMultiplesOfDepositTerm
              ? objList?.inMultiplesOfDepositTerm
              : ""
          } - ${
            objList?.inMultiplesOfDepositTermType?.value
              ? objList?.inMultiplesOfDepositTermType?.value
              : ""
          }`,

          maxDepositTermDisplay:
            objList?.maxDepositTerm && objList?.maxDepositTermType?.value
              ? `${objList.maxDepositTerm} - ${objList.maxDepositTermType.value}`
              : "-",
          maxDepositTerm: objList?.maxDepositTerm || null,
          withHoldTax: objList?.withHoldTax,
          taxGroup: objList?.taxGroup?.name,
        });

        objList?.productOptions?.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.fieldOfficerOptions?.forEach((element) => {
          tempFieldOfficer.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList?.interestCompoundingPeriodTypeOptions?.forEach((element) => {
          tempInterestCompoundingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestPostingPeriodTypeOptions?.forEach((element) => {
          tempInterestPostingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestCalculationTypeOptions?.forEach((element) => {
          tempInterestCalculationTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestCalculationDaysInYearTypeOptions?.forEach(
          (element) => {
            tempInterestCalculationDaysInYearTypeOptions.push({
              value: element.id,
              label: element.value,
            });
          }
        );
        objList?.lockinPeriodFrequencyTypeOptions?.forEach((element) => {
          tempLockinPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.periodFrequencyTypeOptions?.forEach((element) => {
          tempPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.preClosurePenalInterestOnTypeOptions?.forEach((element) => {
          tempPreClosurePenalInterestOnTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.taxGroupOptions?.forEach((element) => {
          tempTaxGroupOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.savingsAccounts
          ?.filter((item) => item.currency?.code === productCurrency)
          .forEach((element) => {
            tempSavingsProductOptions.push({
              value: element.id,
              label: element.savingsProductName,
            });
          });

        objList?.savingsAccounts
          ?.filter((item) => item.currency?.code === productCurrency)
          .forEach((element) => {
            tempSavingsAccountOptions.push({
              value: element.id,
              label: element.accountNo,
              // currency: item.currency?.code, // keep currency if needed later
            });
          });

        objList?.maturityInstructionOptions?.forEach((element) => {
          tempMaturityInstruction.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.accountingMappingOptions?.assetAccountOptions?.forEach(
          (element) => {
            tempAssetOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.accountingMappingOptions?.equityAccountOptions?.forEach(
          (element) => {
            tempEquityOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.accountingMappingOptions?.expenseAccountOptions?.forEach(
          (element) => {
            tempExpenseOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.accountingMappingOptions?.incomeAccountOptions?.forEach(
          (element) => {
            tempIncomeOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.accountingMappingOptions?.liabilityAccountOptions?.forEach(
          (element) => {
            tempLiabilityOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.accountChart?.chartSlabs?.forEach((element) => {
          tempInterestRateChart.push({
            periodType: element.periodType?.value
              ? element.periodType?.value
              : "-",
            fromPeriodTo: `${element.fromPeriod ? element.fromPeriod : " "} - ${
              element.toPeriod ? element.toPeriod : " "
            }`,
            amountRange: `${
              element.amountRangeFrom
                ? element.amountRangeFrom?.toLocaleString()
                : " "
            } - ${
              element.amountRangeTo
                ? element.amountRangeTo?.toLocaleString()
                : " "
            }`,
            interest: element.annualInterestRate
              ? element.annualInterestRate
              : "-",
            fromPeriod: element.fromPeriod ? element.fromPeriod : "-",
            toPeriod: element.toPeriod ? element.toPeriod : "-",
            periodTypeId: element?.periodType ? element?.periodType?.id : "-",
            description: element?.description ? element?.description : "-",
          });
        });
        objList?.charges?.forEach((element, index) => {
          tempCharges.push({
            key: index + 1,
            id: element?.chargeId ? element?.chargeId : "-",
            name: element?.name ? element?.name : "-",
            type: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            amount: element?.amount ? (
              <Statistic
                value={element?.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              0
            ),
            amountToUse: element.amount ? element.amount : 0,
            collectedOn: element?.chargeTimeType?.value
              ? element?.chargeTimeType?.value
              : "-",
            feeOnMonthDay: element?.feeOnMonthDay
              ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
              : "-",

            feeInterval: element?.feeInterval?.value
              ? element?.feeInterval?.value
              : "-",
          });
        });

        objList?.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        objList?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        setInterestChartDate(tempFromDate);
        setSavingsAccountData(tempSavingsAccountOptions);
        setSavingsProductData(tempSavingsProductOptions);
        setMaturityInstructionData(tempMaturityInstruction);
        setFieldOfficerData(tempFieldOfficer);
        setCurrencyData(tempCurrency);
        setInterestCompoundingPeriodTypeOptions(
          tempInterestCompoundingPeriodTypeOptions
        );
        setInterestPostingPeriodTypeOptions(
          tempInterestPostingPeriodTypeOptions
        );
        setInterestCalculationTypeOptions(tempInterestCalculationTypeOptions);
        setInterestCalculationDaysInYearTypeOptions(
          tempInterestCalculationDaysInYearTypeOptions
        );
        setLockinPeriodFrequencyTypeOptions(
          tempLockinPeriodFrequencyTypeOptions
        );
        setPeriodFrequencyTypeOptions(tempPeriodFrequencyTypeOptions);
        setInterestRateChartTableSource(tempInterestRateChart);
        setChargeTableSource(tempCharges);
        const chargeForTableData = tempChargesOptions.filter(
          (item) => item.currencyCode === tempCurrency.code
        );
        useForm.setFieldsValue({
          chargeId: "",
        });
        setChargesOptions([...chargeForTableData]);
        setPreClosure(objList.preClosurePenalApplicable);
        setIsWithholdTaxValue(objList.withHoldTax);
        setIsProductSelected(true);
        setIsLoading(false);
      }
    });
  };

  const onChange = (value) => {
    setCurrent(value);
  };

  const onFinishDetailsForm = (values) => {
    values.submittedOnDate = values.submittedOnDate
      ? BOM.DateTime(values.submittedOnDate, "only-date")
      : values.submittedOnDate;
    setFormData({ ...formData, details: values });
    setCurrent(current + 1);
  };

  const onFinishTermsForm = (values) => {
    values.expectedFirstDepositOnDate = values.expectedFirstDepositOnDate
      ? BOM.DateTime(values.expectedFirstDepositOnDate, "only-date")
      : values.expectedFirstDepositOnDate;
    setFormData({ ...formData, terms: values });
    setCurrent(current + 1);
  };

  const onFinishSettingsForm = (values) => {
    setFormData({ ...formData, settings: values });
    setCurrent(current + 1);
  };

  const onFinishInterestRateChart = (values) => {
    // console.log(values);

    let chartSlabs = [];
    interestRateChartTableSource.forEach((element, index) => {
      chartSlabs.push({
        amountRangeFrom: element.amountRange,
        annualInterestRate: element.interest,
        fromPeriod: element.fromPeriod,
        incentives: [],
        locale: "en",
        periodType: element.periodTypeId,
        toPeriod: element.toPeriod,
      });
    });

    values.charts = [
      {
        fromDate: BOM.DateTime(interestChartDate, "only-date"),
        locale: "en",
        dateFormat: "dd MMMM yyyy",
        isActiveChart: true,
        chartSlabs,
      },
    ];

    setFormData({ ...formData, interestRateChart: values });
    setCurrent(current + 1);
  };

  // const onFinishChargeForm = (values) => {
  //   let tempChargeArray = [];
  //   chargeTableSource.forEach((element, index) => {
  //     if (element.feeOnMonthDay === "-") {
  //       tempChargeArray.push({
  //         chargeId: element.id,
  //         amount: element.amountToUse,
  //       });
  //     } else {
  //       tempChargeArray.push({
  //         chargeId: element.id,
  //         amount: element.amountToUse,
  //         feeOnMonthDay: BOM.DateTimeWithoutYear(
  //           element.feeOnMonthDay,
  //           "only-date"
  //         ),
  //       });
  //     }
  //   });

  //   values.charges = tempChargeArray;

  //   delete values.chargeId;

  //   setFormData({
  //     ...formData,
  //     charges: values.charges,
  //   });
  //   setCurrent(current + 1);
  // };
  const onFinishChargeForm = (values) => {
    let tempChargeArray = [];
    chargeTableSource.forEach((element, index) => {
      const chargeObj = {
        chargeId: element.id,
        amount: element.amountToUse,
      };

      if (element.feeOnMonthDay !== "-") {
        const collectedOn = element.collectedOn?.toLowerCase().trim();

        if (collectedOn === "annual fee" || collectedOn === "monthly fee") {
          chargeObj.feeOnMonthDay = BOM.DateTimeWithoutYear(
            element.feeOnMonthDay,
            "only-date"
          );
        } else if (
          collectedOn === "weekly fee" ||
          collectedOn === "specified due date"
        ) {
          chargeObj.dueDate = BOM.DateTime(element.feeOnMonthDay, "only-date");
        } else if (element.feeOnMonthDay) {
          chargeObj.feeOnMonthDay = BOM.DateTimeWithoutYear(
            element.feeOnMonthDay,
            "only-date"
          );
        }
      }

      tempChargeArray.push(chargeObj);
    });

    values.charges = tempChargeArray;
    delete values.chargeId;

    setFormData({
      ...formData,
      charges: values.charges,
    });

    setCurrent(current + 1);
  };

  const forms = [
    <DetailsForm
      onSearch={onSearch}
      searchParam={searchParam}
      customerInfo={customerInfo}
      showDetailsForm={showDetailsForm}
      onFinish={onFinishDetailsForm}
      form={useForm}
      initialValues={formData.details}
      onChangeProduct={onChangeProduct}
      productData={productData}
      fieldOfficerData={fieldOfficerData}
      handleSearchInTable={handleSearchInTable}
      isProductSelected={isProductSelected}
      savingsAccountOptions={savingsAccountData}
    />,

    <TermsForm
      onFinish={onFinishTermsForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.terms}
      form={useForm}
      interestCompoundingPeriodTypeOptions={
        interestCompoundingPeriodTypeOptions
      }
      interestPostingPeriodTypeOptions={interestPostingPeriodTypeOptions}
      interestCalculationTypeOptions={interestCalculationTypeOptions}
      interestCalculationDaysInYearTypeOptions={
        interestCalculationDaysInYearTypeOptions
      }
      lockinPeriodFrequencyTypeOptions={lockinPeriodFrequencyTypeOptions}
      periodFrequencyTypeOptions={periodFrequencyTypeOptions}
    />,

    <SettingsForm
      onFinish={onFinishSettingsForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.settings}
      form={useForm}
      maturityInstructionOptions={maturityInstructionData}
      savingsAccountOptions={savingsAccountData}
      savingsProductOptions={savingsProductData}
      isWithholdTaxValue={isWithholdTaxValue}
      preClosure={preClosure}
    />,

    <InterestRateChart
      onFinish={onFinishInterestRateChart}
      form={useForm}
      interestRateChartTableSource={interestRateChartTableSource}
      setInterestRateChartTableSource={setInterestRateChartTableSource}
    />,

    <ChargesForm
      onFinish={onFinishChargeForm}
      form={useForm}
      chargesOptions={chargesOptions}
      userData={userData}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      chargeTableSource={chargeTableSource}
      setChargeTableSource={setChargeTableSource}
      initialValues={formData.charges}
      setChargesValue={setChargesValue}
    />,

    <Preview
      formData={formData}
      currencyData={currencyData}
      customerInfo={customerInfo}
      templateProdDetail={templateProdDetail}
      productData={productData}
      interestRateChartTableSource={interestRateChartTableSource}
      chargeTableSource={chargeTableSource}
      preClosure={preClosure}
    />,
  ];

  const isLastStep = current === forms.length - 1;

  const nextButtonClick = () => {
    useForm.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  function onCancel() {
    navigate("/acc0107", { replace: false });
  }

  const onSubmit = () => {
    if (!customerInfo?.entityId) {
      return BOM.AlertMsg(cnt.DANGER, "Customer information is required");
    }

    const {
      inMultiplesOfDepositTerm,
      inMultiplesOfDepositTermType,
      preClosurePenalApplicable,
      preClosurePenalInterest,
      preClosurePenalInterestOnType,
      minDepositTerm,
      minDepositTermType,
      maxDepositTerm,
      maxDepositTermType,
      nominalAnnualInterestRate,
    } = templateProdDetail || {};

    const formValues = {
      ...formData.details,
      ...formData.terms,
      ...formData.settings,
      ...formData.interestRateChart,
      charges: formData?.charges || [],
      clientId: customerInfo.entityId,
      withHoldTax: isWithholdTaxValue,
      dateFormat: "dd MMMM yyyy",
      monthDayFormat: "dd MMMM",
      locale: "en",
      ...(inMultiplesOfDepositTerm && {
        inMultiplesOfDepositTerm,
        inMultiplesOfDepositTermTypeId: inMultiplesOfDepositTermType?.id,
      }),
      ...(preClosurePenalApplicable && {
        preClosurePenalInterest,
        preClosurePenalInterestOnTypeId: preClosurePenalInterestOnType?.id,
      }),
      ...(minDepositTerm && {
        minDepositTerm,
        minDepositTermTypeId: minDepositTermType?.id,
      }),
      ...(maxDepositTerm && {
        maxDepositTerm,
        maxDepositTermTypeId: maxDepositTermType?.id,
      }),
      ...(preClosurePenalApplicable !== undefined && {
        preClosurePenalApplicable,
      }),
      ...(nominalAnnualInterestRate !== undefined && {
        nominalAnnualInterestRate,
      }),
    };

    [
      "decimalPlaces",
      "currencyName",
      "inMultiplesOf",
      "taxGroup",
      "depositRollover",
      "preMatureClosure",
      "minDepositTermDisplay",
      "maxDepositTermDisplay",
      "minBalanceForInterestCalculation",
      ...(!inMultiplesOfDepositTerm ? ["inMultiplesOfDepositTerm"] : []),
    ].forEach((key) => delete formValues[key]);

    const body = {
      ...formValues,
      method: "POST",
      session,
    };
    // console.log(body);
    // return;

    setIsLoading(true);

    BOM.FetchReqAction(
      body,
      apiConfig.Recurringdepositaccounts,
      (err, res) => {
        setIsLoading(false);
        if (err)
          return BOM.AlertMsg(
            cnt.DANGER,
            err?.errors?.[0]?.defaultUserMessage || "An error occurred"
          );
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.newRecurringDepositAccountMsg);
        navigate("/acc0107");
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: () => {
          setIsLoading(false);
          navigate("/acc0107");
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.newRecurringDepositAccount}
        pageItems={staticConfig.newRecurringDepositBreadcrumbItems}
      />
      <Spin spinning={isLoading} tip="Loading..." size="large">
        <Card title={labelConfig.accountSetup} style={styles.cardWrapper}>
          <div>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
              style={{ marginBottom: 25 }}
            >
              <Col span={24}>
                <Row style={{ justifyContent: "space-between" }}>
                  <Card style={styles.cardSteps}>
                    <Steps
                      current={current}
                      onChange={onChange}
                      direction="vertical"
                      style={{ height: "500px" }}
                      items={[
                        {
                          title: <Text strong>{labelConfig.details}</Text>,
                        },

                        {
                          title: <Text strong>{labelConfig.terms}</Text>,
                          disabled: !isProductSelected,
                        },

                        {
                          title: <Text strong>{labelConfig.settings}</Text>,
                          disabled: !isProductSelected,
                        },

                        {
                          title: (
                            <Text strong>{labelConfig.interestRateChart}</Text>
                          ),
                          disabled: !isProductSelected,
                        },

                        {
                          title: <Text strong>{labelConfig.charges}</Text>,
                          disabled: !isProductSelected,
                        },

                        {
                          title: <Text strong>{labelConfig.preview}</Text>,
                          disabled: !isProductSelected,
                        },
                      ]}
                    />
                  </Card>
                  {/* Form Section */}
                  <Card style={styles.cardStepDisplay}>
                    <div>{forms[current]}</div>
                  </Card>
                </Row>
              </Col>
            </Row>

            {/* Submitt section */}
            <Card
              style={{
                marginBottom: 25,
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
                padding: 5,
              }}
            >
              <Flex
                justify="space-between"
                style={{ paddingLeft: "20px", paddingRight: "40px" }}
              >
                {current === 0 && (
                  <Button
                    style={{
                      width: "12%",
                      height: "15%",
                      backgroundColor: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                      color: "black",
                    }}
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#15CCAE",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={prevButtonClick}
                  >
                    {labelConfig.previous}
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#15CCAE",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={nextButtonClick}
                    disabled={!isProductSelected}
                  >
                    {labelConfig.next}
                  </Button>
                )}
                {BOM.HasPermission("CREATE_FIXEDDEPOSITACCOUNT") &&
                  isLastStep && (
                    <CustomButton
                      content="Submit"
                      style={{
                        width: "10%",
                        marginLeft: "auto",
                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      }}
                      onClick={onSubmit}
                      backgroundColor="#fff"
                      colorText="black"
                      hoverBackground="#F5F5F5"
                    />
                  )}
              </Flex>
            </Card>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewRecurringDepositAccount);
